import { Injectable, Inject } from "@angular/core";
import { Router, CanActivate } from "@angular/router";

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router) {
  }

  canActivate() {
    if (localStorage.getItem('loggedInUser')) {
      return true;
    } else {
      if (location && location.hash) {
        let pathTo = location.hash.split('#');
        localStorage.setItem('redirectAfterLogin', pathTo[1]);
      }
      this.router.navigate(['/login']);
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/_guards/auth.guard.ts